import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { generateIdRoutePath } from '../../helpers';
import RallyInfoCard from '../../ui/RalliyInfoCard';
import { APP_ROUTES } from '../../app.config.vars/routes';
import Headline from '../../ui/Headline';
import { useTranslation } from 'react-i18next';
const RalliesList = ({ highlightedRallyId }) => {
    const { t } = useTranslation();
    const rallies = useSelector((state) => state.ralliesPreview.rallies);
    return (_jsx("div", { className: "rallies-list", children: !!rallies.length ? (rallies.map((rally) => (_jsx(NavLink, { to: generateIdRoutePath(APP_ROUTES.rallyPreview, rally.uuid), children: _jsx(RallyInfoCard, { themes: rally.themes, title: rally.publicTitle, geographicArea: rally.geographicArea, targetGroups: rally.targetGroups, hasLocation: rally.latitude !== null && rally.longitude !== null && rally.latitude !== 0 && rally.longitude !== 0, isHighlighted: highlightedRallyId === rally.uuid, rallyId: `rally-${rally.uuid}` }) }, rally.uuid)))) : (_jsx(Headline, { title: t('no_rallies_found'), type: 'h3' })) }));
};
export default RalliesList;
